console.log('Made in Whistler by Alchemy Mapping Solutions/Mike Hamilton.');
const BASE_URL = 'https://wb.alchemymapping.com';
var map = new mapboxgl.Map({
  container: 'map',
  style: {
    glyphs: 'https://dvn3ptw8fp74t.cloudfront.net/{fontstack}/{range}.pbf',
    version: 8,
    sources: {
      'osm-tiles': {
        type: 'raster',
        tiles: [
          'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
          'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
        ],
        tileSize: 256
      }
    },
    layers: [{
      id: 'osm-tiles',
      type: 'raster',
      source: 'osm-tiles',
      minzoom: 0,
      maxzoom: 22
    }]
  },
  center: [-122.937613, 50.099706], // starting position
  zoom: 12, // starting zoom
  bearing: 150
});

map.on('load', function () {
  // DEFAULT LIST OF LAYERS TO SHOW ON LOAD
  show_sat_2014_40cm_tiles();
  show_snowmaking_hydrants(true);
  $('#loading').fadeOut();
  map.resize();
});

var state_sat_2014_40cm_tiles;

// FUNCTION TO LOAD SAT IMAGE
function show_sat_2014_40cm_tiles() {
  state_sat_2014_40cm_tiles = 0;
  $('#sat_2014_40cm_check').prop('checked', true);
  map.addSource('sat-2014-40cm-tiles', {
    type: 'raster',
    tiles: ['https://d1dsfrg9q75324.cloudfront.net/{z}/{x}/{y}.png'],
    tileSize: 256
  });

  map.addLayer({
    id: 'sat-2014-40cm-tiles',
    type: 'raster',
    source: 'sat-2014-40cm-tiles'
  });
}

// FUNCTION TO TOGGLE SAT IMAGE
export function toggle_sat_2014_40cm_tiles() {
  if (state_sat_2014_40cm_tiles == 1) {
    state_sat_2014_40cm_tiles = 0;
    map.setLayoutProperty('sat-2014-40cm-tiles', 'visibility', 'visible');
    $('#sat_2014_40cm_check').prop('checked', true);
  } else if (state_sat_2014_40cm_tiles == 0) {
    state_sat_2014_40cm_tiles = 1;
    map.setLayoutProperty('sat-2014-40cm-tiles', 'visibility', 'none');
    $('#sat_2014_40cm_check').prop('checked', false);
  }
}

function show_snowmaking_hydrants(toggle) {
  if (toggle == true) {
    map.addSource('hydrants', {
      type: 'geojson',
      data: 'https://app.wbsnowmaking.com/geojson/hydrants.geojson',
      cluster: true,
      clusterMaxZoom: 13,
      clusterRadius: 40
    });

    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'hydrants',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': [
          'step', ['get', 'point_count'],
          '#51bbd6',
          100,
          '#f1f075',
          750,
          '#f28cb1'
        ],
        'circle-radius': [
          'step', ['get', 'point_count'],
          20,
          100,
          30,
          750,
          40
        ]
      }
    });

    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'hydrants',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['Open Sans Semibold'],
        'text-size': 14
      }
    });

    map.addLayer({
      filter: ['==', 'c_colour', 'Grey'],
      id: 'hydrants-grey',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Grey',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Black
    map.addLayer({
      filter: ['==', 'c_colour', 'Black'],
      id: 'hydrants-black',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Black',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS White
    map.addLayer({
      filter: ['==', 'c_colour', 'White'],
      id: 'hydrants-white',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'White',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Purple
    map.addLayer({
      filter: ['==', 'c_colour', 'Purple'],
      id: 'hydrants-purple',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Purple',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Blue
    map.addLayer({
      filter: ['==', 'c_colour', 'Blue'],
      id: 'hydrants-blue',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Blue',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Red
    map.addLayer({
      filter: ['==', 'c_colour', 'Red'],
      id: 'hydrants-red',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Red',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Green
    map.addLayer({
      filter: ['==', 'c_colour', 'Green'],
      id: 'hydrants-green',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Green',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS None
    map.addLayer({
      filter: ['==', 'c_colour', 'None'],
      id: 'hydrants-none',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'White',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Yellow
    map.addLayer({
      filter: ['==', 'c_colour', 'Yellow'],
      id: 'hydrants-yellow',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Yellow',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS #49c6bc
    map.addLayer({
      filter: ['==', 'c_colour', '#49c6bc'],
      id: 'hydrants-49c6bc',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': '#49c6bc',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // HYDRANTS Orange
    map.addLayer({
      filter: ['==', 'c_colour', 'Orange'],
      id: 'hydrants-orange',
      type: 'circle',
      source: 'hydrants',
      paint: {
        'circle-radius': 4,
        'circle-color': 'Orange',
        'circle-stroke-width': 1,
        'circle-stroke-color': 'Black'
      }
    });

    // RED LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'Red'],
      id: 'hydrants-label-red',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'Red',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // GREEN LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'Green'],
      id: 'hydrants-label-green',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'Green',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // PURPLE LABELS
    map.addLayer({
      'filter': ['==', 'h_colour', 'Purple'],
      'id': 'hydrants-label-purple',
      'type': 'symbol',
      'source': 'hydrants',
      'layout': {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      'paint': {
        'text-color': 'Purple',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // BLUE LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'Blue'],
      id: 'hydrants-label-blue',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'Blue',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // ORANGE LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'Orange'],
      id: 'hydrants-label-orange',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'Orange',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // YELLOW LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'Yellow'],
      id: 'hydrants-label-yellow',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'Yellow',
        'text-halo-color': '#fff',
        'text-halo-width': 2
      }
    });

    // WHITE LABELS
    map.addLayer({
      filter: ['==', 'h_colour', 'White'],
      id: 'hydrants-label-white',
      type: 'symbol',
      source: 'hydrants',
      layout: {
        'text-field': '{hydrnt_num}',
        'text-anchor': 'left',
        'text-allow-overlap': true,
        'text-offset': [0.4, 0],
        'icon-allow-overlap': true,
        'text-font': ['Open Sans Semibold']
      },
      paint: {
        'text-color': 'White',
        'text-halo-color': 'Grey',
        'text-halo-width': 2
      }
    });

  } else if (toggle == false) {
    map.removeLayer('hydrants-grey');
    map.removeLayer('hydrants-black');
    map.removeLayer('hydrants-white');
    map.removeLayer('hydrants-purple');
    map.removeLayer('hydrants-blue');
    map.removeLayer('hydrants-red');
    map.removeLayer('hydrants-green');
    map.removeLayer('hydrants-none');
    map.removeLayer('hydrants-yellow');
    map.removeLayer('hydrants-orange');
    map.removeLayer('hydrants-49c6bc');

    map.removeLayer('hydrants-label-red');
    map.removeLayer('hydrants-label-green');
    map.removeLayer('hydrants-label-orange');
    map.removeLayer('hydrants-label-yellow');
    map.removeLayer('hydrants-label-white');
    map.removeLayer('hydrants-label-blue');
    map.removeLayer('hydrants-label-purple');
  }
}

var draw = new MapboxDraw({
  displayControlsDefault: false,
  controls: {
    polygon: true,
    line_string: true,
    trash: true
  }
});

map.on('mousemove', function (e) {
  var features = map.queryRenderedFeatures(e.point, {
    layers: ['gl-draw-polygon-fill-inactive.cold', 'gl-draw-line-inactive.cold']
  });

  if (!features.length) {
    clearHint();
    return;
  }

  var feature = features[0];
  var sourceId = feature.properties.id;
  var sourceFeature = map.querySourceFeatures(sourceId);
  console.log(JSON.stringify(feature));


  function getArea(feature) {
    let areaMeters = turf.area(feature);
    switch (true) {
      case (areaMeters <= 9999):
        return (areaMeters) + ' m&sup2;';
      case (areaMeters > 9999 && areaMeters <= 999999):
        return (areaMeters / 10000) + ' ha&sup2;';
      case (areaMeters > 999999):
        return (areaMeters / 1000000) + ' km&sup2';
    }
  }

  function getLength(feature) {
    let lengthMeters = turf.length(feature, {
      units: 'meters'
    });
    switch (true) {
      case (lengthMeters <= 999):
        return lengthMeters + ' m';
      case (lengthMeters > 999):
        return (lengthMeters / 1000) + ' km';
    }
  }

  function getPerimeter(feature) {
    let perimeterMeters = turf.length(feature, {
      units: 'meters'
    });
    switch (true) {
      case (perimeterMeters <= 999):
        return perimeterMeters + ' m';
      case (perimeterMeters > 999):
        return (perimeterMeters / 1000) + ' km';
    }
  }

  function setHint(string) {
    $('#hint-area').html(string).show();
  }

  function clearHint() {
    $('#hint-area').hide();
  }

  if (feature.geometry.type == 'Polygon') {
    setHint('Area: ' +
      getArea(feature) +
      '<br>' +
      'Perimeter: ' +
      getPerimeter(feature)
    );
  } else if (feature.geometry.type == 'LineString') {
    setHint('Length: ' +
      getLength(feature)
    );
  }
});

map.addControl(new mapboxgl.NavigationControl());
map.addControl(new mapboxgl.GeolocateControl({
  positionOptions: {
    enableHighAccuracy: true
  },
  trackUserLocation: true
}));
map.addControl(draw);

map.boxZoom.enable();

export function hamburgerClick() {
  if ($('.hamburger').hasClass('is-active')) {
    $('.hamburger').removeClass('is-active');
  } else {
    $('.hamburger').addClass('is-active');
  }
}